
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/userDateRangeSearchForm';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<style type=\"text/css\">\n  #userIdSearchField { width: 8em; }\n</style>\n<div class=\"control-group\">\n  <label>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.user_date_range_search_form")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.user_date_range_search_form.search", "Search for people by ID or name", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.user_date_range_search_form.search", "Search for people by ID or name", options)))
    + "\n    <br>\n    <input\n      type=\"text\"\n      name=\"search_term\"\n      data-view=\"inputFilter\"\n      maxlength=\"255\"\n    >\n  </label>\n\n  <input\n    type=\"hidden\"\n    class=\"userIdField\"\n    name=\"user_id\"\n    maxlength=\"255\"\n  >\n\n  <input\n    type=\"hidden\"\n    class=\"hiddenDateStart\"\n    name=\"start_time\"\n  />\n\n  <input\n    type=\"hidden\"\n    class=\"hiddenDateEnd\"\n    name=\"end_time\"\n  />\n</div>\n\n<div class=\"v-gutter\">\n  <h2 class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.user_date_range_search_form")
  },data:data},helper ? helper.call(depth0, "users_d1b60cb0", "Users", options) : helperMissing.call(depth0, "t", "users_d1b60cb0", "Users", options)))
    + "</h2>\n  <div data-view=\"users\" class=\"users-container\"></div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  